function calculateColumns(arr, width) {
    var autoColumn = -1, flexColumns = [], flexUnits = 0, widthUsed = 0, ret = [], i;
    for (i = 0; i < arr.length; i++) {
        var w;
        if (typeof arr[i] === "object" && arr[i].unit) {
            if (arr[i].unit === "fr") {
                if (autoColumn > -1)
                    throw new Error("Can't mix 'fr' units and 'auto'.");
                w = null;
                flexColumns.push(i);
                flexUnits += arr[i].value;
            }
            if (arr[i].unit === "pt")
                w = arr[i].value;
            if (arr[i].unit === "pct")
                w = (arr[i].value * width) / 100;
        }
        else if (arr[i] === "auto") {
            if (flexColumns.length)
                throw new Error("Can't mix 'fr' units and 'auto'.");
            if (autoColumn > -1)
                throw new Error("Only one column can be auto");
            autoColumn = i;
            w = null;
        }
        else if (arr[i] >= 0 && arr[i] <= 1) {
            w = arr[i] * width;
        }
        else {
            w = arr[i];
        }
        widthUsed += w;
        ret.push(w);
    }
    if (autoColumn > -1) {
        ret[autoColumn] = width - widthUsed;
    }
    if (flexColumns.length) {
        for (i = 0; i < flexColumns.length; i += 1) {
            ret[flexColumns[i]] = (arr[flexColumns[i]].value / flexUnits) * (width - widthUsed);
        }
    }
    return ret;
}
module.exports = {
    calculateColumns: calculateColumns
};
//# sourceMappingURL=module.js.map